import { useCount } from "@/utils/count";

const load = async () => {
    const count = useCount();
    await count.countOmpStat();
};
export default [
    {
        path: "/omp",
        name: "omp__root__",
        redirect: {
            name: "omp-index",
        },
        component: () => import("@/layouts/default.vue"),
        meta: {
            parent: "omp",
            title: "",
        },
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "index",
                name: "omp-index",
                component: () => import("@/views/omp/index.vue"),
                meta: {
                    title: "控制面板",
                    icon: "index",
                    affix: true,
                },
            },
        ],
    },
    {
        path: "/omp/conf",
        name: "omp-conf",
        meta: {
            title: "基础设置",
            icon: "atom",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/conf/global",
        children: [
            {
                path: "global",
                name: "omp-conf-global",
                component: () => import("@/views/omp/conf/index"),
                meta: {
                    title: "配置管理",
                    icon: "global",
                    affix: false,
                    permission: "manage_system_conf",
                },
            },
            {
                path: "notice",
                name: "omp-conf-notice",
                component: () => import("@/views/omp/conf/notice"),
                meta: {
                    title: "公告管理",
                    icon: "notice",
                    affix: false,
                    permission: "manage_common_notice",
                },
            },
            {
                path: "menu",
                name: "omp-conf-menu",
                component: () => import("@/views/omp/conf/menu"),
                meta: {
                    title: "菜单管理",
                    icon: "menu",
                    affix: false,
                    permission: "manage_common_menu",
                },
            },
            {
                path: "banner",
                name: "cms-promotion-banner",
                component: () => import("@/views/cms/promotion/banner.vue"),
                meta: {
                    title: "海报管理",
                    icon: "banner",
                    affix: false,
                    permission: "manage_common_banner",
                },
            },
            {
                path: "block",
                name: "cms-block",
                component: () => import("@/views/cms/content/block"),
                meta: {
                    title: "模块管理",
                    icon: "cms-block",
                    affix: false,
                    permission: "manage_www_block",
                },
            },
            {
                path: "block/:id(\\d+)+",
                name: "cms-blockDetail",
                hidden: true,
                component: () => import("@/views/cms/content/block_detail"),
                meta: {
                    title: "模块详情",
                    affix: false,
                    activeMenu: "/omp/conf/block",
                    permission: "manage_www_block",
                },
            },
            {
                path: "page",
                name: "cms-page",
                component: () => import("@/views/cms/content/page"),
                meta: {
                    title: "页面管理",
                    icon: "cms-page",
                    affix: false,
                    permission: "manage_www_page",
                },
            },
            {
                path: "page/:id(\\d+)+",
                name: "cms-pageDetail",
                hidden: true,
                component: () => import("@/views/cms/content/detail"),
                meta: {
                    title: "页面详情",
                    affix: false,
                    activeMenu: "/omp/conf/page",
                    permission: "manage_www_page",
                },
            },
            {
                path: "page/:pageId(\\d+)+/meta/:metaId(\\d+)?",
                name: "cms-metaDetail",
                hidden: true,
                component: () => import("@/views/cms/content/meta"),
                meta: {
                    title: "属性详情",
                    affix: false,
                    activeMenu: "/omp/conf/page",
                    permission: "manage_www_page",
                },
            },
        ],
    },
    /*
    {
        path: "/cms/promotion",
        name: "cms-promotion",
        meta: {
            title: "推广中心",
            icon: "promotion",
            parent: "omp",
            permission: "manage_common_banner",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/promotion/banner",
        children: [
            {
                path: "banner",
                name: "cms-promotion-banner",
                component: () => import("@/views/cms/promotion/banner.vue"),
                meta: {
                    title: "图文推广",
                    icon: "banner",
                },
            },
        ],
    },
    */
    {
        path: "/cms/ai",
        name: "cms-ai",
        meta: {
            title: "智能回复",
            icon: "ai",
            parent: "omp",
            permission: "manage_ai",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/ai/keyword",
        children: [
            {
                path: "keyword",
                name: "cms-ai-keyword",
                component: () => import("@/views/cms/ai/keyword.vue"),
                meta: {
                    title: "关键词",
                    icon: "intelligence-keywords",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "keyword-detail/:id",
                name: "keyword-detail",
                component: () => import("@/views/cms/ai/keyword-detail.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/ai/keyword",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "keyword-edit/:id?",
                name: "keyword-edit",
                component: () => import("@/views/cms/ai/keyword-edit.vue"),
                hidden: true,
                meta: {
                    title: "策略详情",
                    activeMenu: "/cms/ai/keyword",
                    permission: "manage_ai_keyword",
                },
            },
            {
                path: "vocabulary",
                name: "intelligence-vocabulary",
                component: () => import("@/views/cms/ai/vocabulary.vue"),
                meta: {
                    title: "语音词",
                    icon: "intelligence-vocabulary",
                    permission: "manage_ai_pronunciation",
                },
            },
            {
                path: "vocabulary-detail/:id",
                name: "intelligence-vocabulary-detail",
                component: () => import("@/views/cms/ai/vocabulary-detail.vue"),
                hidden: true,
                meta: {
                    title: "语音热词详情",
                    activeMenu: "/cms/ai/vocabulary",
                    permission: "manage_ai_pronunciation",
                },
            },
            {
                path: "rag",
                name: "intelligence-rag",
                component: () => import("@/views/cms/ai/rag.vue"),
                meta: {
                    title: "知识库",
                    icon: "intelligence-rag",
                    permission: "manage_ai_rag",
                },
            },
            {
                path: "rag-detail/:id",
                name: "intelligence-rag-detail",
                component: () => import("@/views/cms/ai/rag-detail.vue"),
                hidden: true,
                meta: {
                    title: "知识库详情",
                    activeMenu: "/cms/ai/rag",
                    permission: "manage_ai_rag",
                },
            },
            {
                path: "chat",
                name: "intelligence-chat",
                component: () => import("@/views/cms/ai/chat.vue"),
                meta: {
                    title: "语料库",
                    icon: "intelligence-chat",
                    permission: "manage_ai_chat",
                },
            },
            {
                path: "chat-edit/:id?",
                name: "intelligence-chat-edit",
                component: () => import("@/views/cms/ai/chat-edit.vue"),
                hidden: true,
                meta: {
                    title: "语料详情",
                    activeMenu: "/cms/ai/chat",
                    permission: "manage_ai_chat",
                },
            },
            {
                path: "history",
                name: "intelligence-history",
                component: () => import("@/views/cms/ai/history.vue"),
                meta: {
                    title: "历史会话",
                    icon: "intelligence-history",
                    permission: "manage_ai_history",
                },
            },
            {
                path: "history-detail/:id",
                name: "intelligence-history-detail",
                component: () => import("@/views/cms/ai/history-detail.vue"),
                hidden: true,
                meta: {
                    title: "会话详情",
                    activeMenu: "/cms/ai/history",
                    permission: "manage_ai_history",
                },
            },
            {
                path: "overview",
                name: "intelligence-overview",
                component: () => import("@/views/cms/ai/overview.vue"),
                meta: {
                    title: "统计分析",
                    icon: "intelligence-stat",
                    permission: "manage_ai_stat",
                },
            },
        ],
    },
    /*
    {
        path: "/cms/document",
        name: "cms-document",
        meta: {
            title: "文档中心",
            icon: "document-mng",
            parent: "omp",
            permission: "manage_common_document",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/document/common",
        children: [
            {
                path: "common",
                name: "cms-document-common",
                component: () => import("@/views/cms/document/index.vue"),
                meta: {
                    title: "通用文档",
                    icon: "document",
                    app: "common",
                },
            },
            {
                path: "fsf",
                name: "cms-document-fsf",
                component: () => import("@/views/cms/document/index.vue"),
                meta: {
                    title: "期权文档",
                    icon: "document",
                    app: "fsf",
                },
            },
            {
                path: "detail/:id(\\d+)?",
                name: "cms-document-detail",
                hidden: true,
                component: () => import("@/views/cms/document/document-form.vue"),
                meta: {
                    title: "文档内容",
                    icon: "document",
                    affix: false,
                },
            },
        ],
    },
    */
    {
        path: "/cms/oss",
        name: "cms-oss",
        meta: {
            title: "资源管理",
            icon: "config-file",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/cms/oss/file",
        children: [
            {
                path: "document",
                name: "cms-document-common",
                component: () => import("@/views/cms/document/index.vue"),
                meta: {
                    title: "文档管理",
                    icon: "document",
                    app: "common",
                    permission: "manage_common_document",
                },
            },
            {
                path: "document/detail/:id(\\d+)?",
                name: "cms-document-detail",
                hidden: true,
                component: () => import("@/views/cms/document/document-form.vue"),
                meta: {
                    title: "文档详情",
                    icon: "document",
                    affix: false,
                    activeMenu: "/cms/oss/document",
                    permission: "manage_common_document",
                },
            },
            {
                path: "file",
                name: "cms-oss-file",
                component: () => import("@/views/cms/oss/file-mng.vue"),
                meta: {
                    title: "文件管理",
                    icon: "oss",
                    permission: "manage_upload_file",
                },
            },
            {
                path: "log",
                name: "cms-oss-log",
                component: () => import("@/views/cms/oss/log.vue"),
                meta: {
                    title: "上传日志",
                    icon: "upload-log",
                    permission: "manage_upload_log",
                },
            },
        ],
    },
    /*
    {
        path: "/cms/content",
        name: "cms-content",
        meta: {
            title: "页面管理",
            icon: "cms-www",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: {
            name: "cms-page",
        },
        children: [
            {
                path: "page",
                name: "cms-page",
                component: () => import("@/views/cms/content/page"),
                meta: {
                    title: "页面管理",
                    icon: "cms-page",
                    affix: false,
                    permission: "manage_www_page",
                },
            },
            {
                path: "page/:id(\\d+)+",
                name: "cms-pageDetail",
                hidden: true,
                component: () => import("@/views/cms/content/detail"),
                meta: {
                    title: "页面详情",
                    affix: false,
                    activeMenu: "/cms/content/page",
                    permission: "manage_www_page",
                },
            },
            {
                path: "/page/:pageId(\\d+)+/meta/:metaId(\\d+)?",
                name: "cms-metaDetail",
                hidden: true,
                component: () => import("@/views/cms/content/meta"),
                meta: {
                    title: "属性详情",
                    affix: false,
                    activeMenu: "/cms/content/page",
                    permission: "manage_www_page",
                },
            },
            {
                path: "block",
                name: "cms-block",
                component: () => import("@/views/cms/content/block"),
                meta: {
                    title: "模块管理",
                    icon: "cms-block",
                    affix: false,
                    permission: "manage_www_block",
                },
            },
            {
                path: "block/:id(\\d+)+",
                name: "cms-blockDetail",
                hidden: true,
                component: () => import("@/views/cms/content/block_detail"),
                meta: {
                    title: "模块详情",
                    affix: false,
                    activeMenu: "/cms/content/block",
                    permission: "manage_www_block",
                },
            },
        ],
    },
    */
    {
        path: "/omp/mall",
        name: "omp-mall",
        meta: {
            title: "商城管理",
            icon: "mall",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/mall/goods",
        children: [
            {
                path: "goods",
                name: "omp-mall-goods",
                component: () => import("@/views/omp/mall/goods"),
                meta: {
                    title: "商品管理",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                },
            },
            {
                path: "goods-detail/:id(\\d+)?",
                name: "omp-mall-goods-detail",
                component: () => import("@/views/omp/mall/goods-detail"),
                hidden: true,
                meta: {
                    title: "商品详情",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                    activeMenu: "/omp/mall/goods",
                },
            },
            {
                path: "goods-data/:id(\\d+)?",
                name: "omp-mall-goods-data",
                component: () => import("@/views/omp/mall/goods-data"),
                hidden: true,
                meta: {
                    title: "商品详情",
                    icon: "goods",
                    affix: false,
                    permission: "manage_mall_goods",
                    activeMenu: "/omp/mall/goods",
                },
            },
            {
                path: "category",
                name: "omp-mall-category",
                component: () => import("@/views/omp/mall/category"),
                meta: {
                    title: "商品分类",
                    icon: "goods_type",
                    affix: false,
                    permission: "manage_mall_goods_category",
                },
            },
            {
                path: "tag",
                name: "omp-mall-tag",
                component: () => import("@/views/omp/mall/tag"),
                meta: {
                    title: "标签管理",
                    icon: "tag",
                    affix: false,
                    permission: "manage_mall_goods_tag",
                },
            },
            {
                path: "decoration",
                name: "omp-mall-decoration",
                component: () => import("@/views/omp/mall/decoration"),
                meta: {
                    title: "装饰管理",
                    icon: "decoration",
                    affix: false,
                    permission: "manage_mall_goods_decoration",
                },
            },
            {
                path: "fee/shipping",
                name: "omp-mall-fee-shipping",
                component: () => import("@/views/omp/mall/shipping-fee"),
                meta: {
                    title: "邮费管理",
                    icon: "shipping",
                    affix: false,
                    permission: "manage_mall_shipping_fee",
                },
            },
        ],
    },
    {
        path: "/omp/server",
        name: "omp-server",
        meta: {
            title: "服务管理",
            icon: "server",
            parent: "omp",
            group: 256,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/server/product",
        children: [
            {
                path: "product",
                name: "dev-conf-product",
                component: () => import("@/views/dev/conf/product.vue"),
                meta: {
                    title: "产品配置",
                    icon: "product",
                    affix: false,
                    group: 512,
                },
            },
            {
                path: "product-detail/:id(\\d+)?",
                name: "dev-conf-product-detail",
                hidden: true,
                component: () => import("@/views/dev/conf/product-detail.vue"),
                meta: {
                    title: "产品配置详情",
                    affix: false,
                    activeMenu: "/omp/server/product",
                    group: 512,
                },
            },
            {
                path: "purchase-record",
                name: "omp-server-purchase-record",
                component: () => import("@/views/dev/conf/purchase-record.vue"),
                meta: {
                    title: "售卖统计",
                    icon: "purchase-records",
                    affix: false,
                },
            },
            {
                path: "exception",
                name: "omp-server-exception",
                component: () => import("@/views/omp/server/exception.vue"),
                meta: {
                    title: "异常处理",
                    icon: "exception-handle",
                    affix: false,
                },
            }
        ]
    },
    {
        path: "/omp/promotion",
        name: "omp-promotion",
        meta: {
            title: "推广管理",
            icon: "gift",
            parent: "omp",
            group: 256,
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/promotion/voucher-type",
        children: [
            // =========== 礼品卡 ===========
            {
                path: "voucher-type",
                name: "omp-promotion-voucher-type",
                component: () => import("@/views/omp/promotion/voucher/voucher-type.vue"),
                meta: {
                    title: "礼品卡配置",
                    icon: "gift-card-config",
                    affix: false,
                },
            },
            {
                path: "voucher-batch",
                name: "omp-promotion-voucher-batch",
                component: () => import("@/views/omp/promotion/voucher/voucher-batch-list.vue"),
                meta: {
                    title: "礼品卡管理",
                    icon: "gift-card",
                    affix: false,
                },
            },
            {
                path: "voucher/:id(\\d+)",
                name: "omp-promotion-voucher-detail",
                component: () => import("@/views/omp/promotion/voucher/voucher-batch-detail.vue"),
                hidden: true,
                meta: {
                    title: "批次详情",
                    icon: "promotion",
                    affix: false,
                    activeMenu: "/omp/promotion/voucher-batch",
                },
            },
            {
                path: "third-party-redemptions",
                name: "omp-promotion-third-party-redemptions",
                component: () => import("@/views/omp/promotion/voucher/third-party-redemptions.vue"),
                hidden: true,
                meta: { title: "第三方核销记录", icon: "gift", affix: false, activeMenu: "/omp/promotion/voucher-batch" },
            },
            // =========== 幸运码 ===========
            {
                path: "lucky-setting",
                name: "omp-promotion-lucky-setting",
                component: () => import("@/views/omp/promotion/lucky/lucky-setting.vue"),
                meta: {
                    title: "推广码配置",
                    icon: "lucky-manage",
                    affix: false,
                },
            },
            {
                path: "lucky-manage",
                name: "omp-promotion-lucky-manage",
                component: () => import("@/views/omp/promotion/lucky/lucky-manage.vue"),
                meta: {
                    title: "推广码管理",
                    icon: "lucky",
                    affix: false,
                },
            },
            {
                path: "lucky-detail/:id(\\d+)?",
                name: "omp-promotion-lucky-detail",
                component: () => import("@/views/omp/promotion/lucky/lucky-detail.vue"),
                hidden: true,
                meta: {
                    title: "推广码详情",
                    icon: "lucky",
                    affix: false,
                    activeMenu: "/omp/promotion/lucky-manage",
                },
            }
        ]
    },
    {
        path: "/omp/msg",
        name: "omp-msg",
        meta: {
            title: "消息中心",
            icon: "message",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/msg/email",
        children: [
            {
                path: "message",
                name: "omp-msg-message",
                component: () => import("@/views/omp/msg/message.vue"),
                meta: {
                    title: "私信管理",
                    icon: "private",
                    permission: "manage_message",
                },
            },
            {
                path: "email",
                name: "omp-msg-email",
                component: () => import("@/views/omp/msg/email.vue"),
                meta: {
                    title: "邮件管理",
                    icon: "email",
                    permission: "manage_email_log",
                },
            },
            {
                path: "email-sending",
                name: "omp-msg-email-sending",
                hidden: true,
                component: () => import("@/views/omp/msg/email-sending.vue"),
                meta: {
                    title: "发送邮件",
                    affix: false,
                    permission: "send_email",
                    activeMenu: "/omp/msg/email",
                },
            },
            {
                path: "phone-msg",
                name: "omp-msg-phone-msg",
                component: () => import("@/views/omp/msg/phone-msg.vue"),
                meta: {
                    title: "短信管理",
                    icon: "phone-msg",
                    permission: "manage_sms_log",
                },
            },
            {
                path: "phone-sending",
                name: "omp-msg-phone-sending",
                hidden: true,
                component: () => import("@/views/omp/msg/phone-sending.vue"),
                meta: {
                    title: "发送短信",
                    affix: false,
                    permission: "send_sms",
                    activeMenu: "/omp/msg/phone-msg",
                },
            },
            {
                path: "wxmsg",
                name: "omp-msg-wxmsg",
                component: () => import("@/views/omp/msg/wxmsg.vue"),
                meta: {
                    title: "微信管理",
                    icon: "wxmsg",
                    permission: "manage_wxmsg_log",
                },
            },
        ],
    },
    {
        path: "/omp/support",
        name: "omp-support",
        meta: {
            title: "支持中心",
            icon: "support",
            parent: "omp",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/support/contact",
        beforeEnter: async (to, from, next) => {
            await load();
            next();
        },
        children: [
            {
                path: "feedback",
                name: "omp-support-feedback",
                component: () => import("@/views/omp/support/feedback.vue"),
                meta: {
                    title: "反馈管理",
                    icon: "feedback",
                    permission: "manage_common_feedback",
                },
            },
            {
                path: "feedback-detail/:id(\\d+)",
                name: "omp-support-feedback-detail",
                component: () => import("@/views/common/account/feedback-detail.vue"),
                hidden: true,
                meta: {
                    title: "反馈管理",
                    icon: "feedback",
                    permission: "manage_common_feedback",
                    activeMenu: "/omp/support/feedback",
                },
            },
            {
                path: "contact",
                name: "omp-support-contact",
                component: () => import("@/views/omp/support/contact.vue"),
                meta: {
                    title: "留言管理",
                    icon: "comment",
                    permission: "manage_common_contact",
                },
            },
            {
                path: "recruitment",
                name: "omp-support-recruitment",
                component: () => import("@/views/omp/support/recruitment.vue"),
                meta: {
                    title: "招募管理",
                    icon: "talent",
                    permission: "manage_support_recruitment",
                },
            },
            {
                path: "talent",
                redirect: "/omp/support/recruitment",
                hidden: true,
            },
        ],
    },
    {
        path: "/omp/user",
        name: "omp-user",
        meta: {
            title: "用户管理",
            icon: "users",
            parent: "omp",
            permission: "manage_user",
        },
        component: () => import("@/layouts/default.vue"),
        redirect: "/omp/user/account",
        children: [
            {
                path: "account",
                name: "omp-user-account",
                component: () => import("@/views/omp/user/account"),
                meta: {
                    title: "账号管理",
                    icon: "user",
                    affix: false,
                },
            },
            {
                path: "abnormality",
                name: "omp-user-abnormality",
                component: () => import("@/views/omp/user/abnormality"),
                meta: {
                    title: "账号异常",
                    icon: "abnormality",
                    affix: false,
                },
            },
            {
                path: "action-log",
                name: "omp-user-action-log",
                component: () => import("@/views/dev/log/user/action-log.vue"),
                meta: {
                    title: "操作日志",
                    icon: "user-log",
                },
            },
        ],
    },
];
